import { render } from "./IconBoolean.vue?vue&type=template&id=3fc70fec"
import script from "./IconBoolean.vue?vue&type=script&lang=js"
export * from "./IconBoolean.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconBoolean.vue"]])

export default __exports__